module.exports = __webpack_public_path__ + "img/benefit-3-hover.f50015fd.png";